import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginWithToken } from "actions/authActions";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Typography } from "@mui/material";

function TokenValidationWrapper({ children }) {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth?.user);

  const params = new URLSearchParams(location.search);
  const token = params.get("token");

  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [tokenHandled, setTokenHandled] = useState(false);

  useEffect(() => {

    // Case 1: Internal navigation (user already logged in)
    if (!token && user) {
      setChecked(true);
      return;
    }

    // Case 2: External link with token
    if (token && !tokenHandled) {

      const validateToken = async () => {
        try {
          setLoading(true);
          setTokenHandled(true);

          await dispatch(loginWithToken(token));

          const cleanUrl = location.pathname;
          navigate(cleanUrl, { replace: true });

        } catch (err) {
          console.error("Token login failed:", err);
          navigate("/", { replace: true });
        } finally {
          setLoading(false);
          setChecked(true);
        }
      };

      validateToken();
      return;
    }

    // Case 3: No token and no logged user → redirect
    if (!token && !user) {
      navigate("/", { replace: true });
    }

  }, [token, user, tokenHandled, dispatch, navigate, location.pathname]);

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
        <Typography ml={3}>
          Validating secure login link...
        </Typography>
      </Grid>
    );
  }

  if (!checked && token) return null;

  return children;
}

export default TokenValidationWrapper;